module.exports = __webpack_public_path__ + "img/_icon-mymove.08cd5eec.svg";